import { ElementType } from "react";
import StoreIcon from "@mui/icons-material/Store";
import BusinessIcon from "@mui/icons-material/Business";
import ApartmentIcon from "@mui/icons-material/Apartment";

type SelectionConfig = {
  title: string;
  description: string;
  subDescription: string;
  icon: ElementType;
};

const iconColorMap: Record<string, string> = {
  'Small Business': 'text-blue-600',
  'Mid-Market': 'text-purple-600',
  'Enterprise': 'text-orange-600'
};

const sizeSelectionConfig: SelectionConfig[] = [
  {
    title: "Small Business",
    description: "Under 300 per month",
    subDescription: "Perfect for small shops and startups",
    icon: StoreIcon,
  },
  {
    title: "Mid-Market",
    description: "Under 1,000 per month",
    subDescription: "Great for growing businesses",
    icon: BusinessIcon,
  },
  {
    title: "Enterprise",
    description: "Over 1,000 per month",
    subDescription: "For large scale operations",
    icon: ApartmentIcon,
  },
];

type SizeSelectionViewProps = {
  selected: string;
  setSelected: (selected: string) => void;
};

const SizeOption = ({
  title,
  description,
  subDescription,
  Icon,
  isSelected,
  onSelect,
}: {
  title: string;
  description: string;
  subDescription: string;
  Icon: ElementType;
  isSelected: boolean;
  onSelect: () => void;
}) => {
  return (
    <button
      onClick={onSelect}
      className={`w-full p-6 rounded-lg border-2 transition-all duration-200 flex flex-col items-center text-center gap-3 hover:bg-blue-50 ${
        isSelected ? 'border-blue-500 bg-blue-50' : 'border-gray-200'
      }`}
    >
      <div className="flex-shrink-0">
        <Icon className={`w-12 h-12 ${isSelected ? 'text-blue-600' : iconColorMap[title] || 'text-gray-600'}`} />
      </div>
      <div>
        <h3 className="font-semibold text-lg mb-1">{title}</h3>
        <p className="text-gray-900 text-base font-medium">{description}</p>
        <p className="text-gray-600 text-sm mt-1">{subDescription}</p>
      </div>
      <div className={`w-6 h-6 mt-2 rounded-full border-2 flex items-center justify-center ${
        isSelected ? 'border-blue-500 bg-blue-500' : 'border-gray-300'
      }`}>
        {isSelected && (
          <div className="w-2 h-2 bg-white rounded-full" />
        )}
      </div>
    </button>
  );
};

const SizeSelectionView = ({
  selected,
  setSelected,
}: SizeSelectionViewProps) => {
  return (
    <article className="w-full">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {sizeSelectionConfig.map((config) => (
          <SizeOption
            key={config.title}
            title={config.title}
            description={config.description}
            subDescription={config.subDescription}
            Icon={config.icon}
            isSelected={selected === config.title}
            onSelect={() => setSelected(config.title)}
          />
        ))}
      </div>
    </article>
  );
};

export default SizeSelectionView;